// extracted by mini-css-extract-plugin
module.exports = {"playerIcon":"_02712f2b3b--playerIcon--uWPqi","playerIconSmall":"_02712f2b3b--playerIconSmall--e2hvw"};